// LICENSE_CODE ZON
/*jslint browser:true, es6:true, node:true, react:true*/
import React, {ReactNode} from 'react';
import {Link} from 'react-router-dom';
import cn from 'classnames';
import {use_theme} from '../../../../../hola/pub/settings_ctx';
import {Trustpilot} from '../trustpilot/trustpilot';
import {Order_summary} from '../order_summary/order_summary';
import {Payment_form_wrapper} from '../payment_form_wrapper/payment_form_wrapper';
import {toolip_img_url} from '../../../../../hola/pub/ui/toolip_img_url';
import styles from './checkout_layout.module.less';
import {t_periods} from '../../../types';
import {Unlimited_bandwidth} from '../unlimited_bandwidth/unlimited_bandwidth';
import {i_plan, i_plan_config} from '../../../../../hola/pub/plus/plus_types';
import {Top_kyc_message, Kyc_modal} from '../../dashboard/kyc/kyc';
import {Button} from '../../../../../hola/pub/lib/button';
import Icon_chevron_left from '../../../img/icons/16/chevron_left.svg';

type t_checkout_layout_props = {
    plan: i_plan;
    plan_config: i_plan_config;
    show_usage_charges: boolean;
    cls?: string;
    form: ReactNode;
    submitting: boolean;
    total: number;
    period: t_periods;
    is_isp?: boolean;
    is_isp_plus?: boolean;
    package_gb: number;
    product_type: string;
    features?: string[];
    ips_amount?: number | undefined;
    purchase_disabled?: boolean;
    usage_charges: boolean;
    on_change_usage_charges: (val: boolean)=>void;
    need_kyc?: boolean;
    title?: string
};

export const Checkout_layout = ({cls, form, submitting, product_type,
    total, period, is_isp, is_isp_plus, features, ips_amount,
    package_gb, on_change_usage_charges, usage_charges, plan,
    plan_config, show_usage_charges, title = 'Checkout',
    purchase_disabled = false, need_kyc = false}: t_checkout_layout_props)=>{
    const {theme} = use_theme();
    return <div className={cn(cls, styles.checkout_page)}>
      <div className={styles.heading_container}>
      <Link className={styles.logo} data-clickid="nav_logo" to="/">
        <img src={toolip_img_url('/toolip/logo_black.svg')}
          alt="Site logo"/>
      </Link>
      <Button caption='Back' icon_left={<Icon_chevron_left/>}
        color='transparent_grey' cls={styles.back_btn}
        on_click={()=>history.back()}/>
      </div>
      <div className={styles.checkout_layout}>
        <div className={styles.body}>
          <div className={styles.col}>
            <Order_summary cls={styles.summary}
              is_isp={is_isp}
              is_isp_plus={is_isp_plus}
              total={total}
              package_gb={package_gb}
              period={period}
              product_type={product_type}
              ips_amount={ips_amount}
            />
            {show_usage_charges && <Unlimited_bandwidth
              cls={cn(styles.unlimited_bandwidth, styles.desktop)}
              usage_charges={usage_charges}
              plan={plan}
              plan_config={plan_config}
              on_change_usage_charges={on_change_usage_charges}
            />}
            <Trustpilot cls={cn(styles.trust, styles.desktop)}
              no_logo features={features}/>
          </div>

          <div className={styles.col}>
          <p className={cn(styles.header, theme.p18, theme.med,
            theme.color_n700)}>
            {title}
          </p>
            <Payment_form_wrapper
              cls={cn(styles.payment_form_wrapper)}
              form={form}
              submitting={submitting}
              period={period}
              total={total}
              purchase_disabled={purchase_disabled}
              need_kyc={need_kyc}
            />
            <Trustpilot cls={cn(styles.trust, styles.mobile)}
              no_logo features={features}/>
            <Kyc_modal site='toolip' />
            <Top_kyc_message />
          </div>
        </div>
      </div>
    </div>;
};
